/**
 * Technology Block.
 * 
 */

/**
 * Desktop: 1-slide slick slider.
 * Mobile: 1-slide slick slider.
 */

// Set up slick slider for benefits slides in mobile.
let 
	$window = $(window),
	sliderBreakpoint = 1024,
	$mySlider = $('.tech-block__slides'),
    mySliderSettings = {
        adaptiveHeight:false,
		arrows:true,
		prevArrow:$('.tech-block__arrow-nav .slick-prev'),
		nextArrow:$('.tech-block__arrow-nav .slick-next'),
		autoplay:true,
		autoplaySpeed:8000,
		// centerMode:true,
		dots: true,
		appendDots: $('.tech-block__dot-nav'),
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
        swipeToSlide:true,
		variableWidth:false,
        responsive: [	// Does this work?
			{
				breakpoint: 1023,
				settings: {
					arrows:false,
					prevArrow:null,
					nextArrow:null
				}
			}
        ]
    };

function initSlider() {
    // console.log('TECHNOLOGY: initSlider()');

	$mySlider.slick(mySliderSettings);
	$('.tech-block__dot-nav').on('mouseenter', function() {
		$mySlider.slick('slickPause');
	});
	$('.tech-block__dot-nav').on('mouseleave', function() {
		$mySlider.slick('slickPlay');
	});
}

let
	prevWindowW = $window.width(),
	currWindowW = prevWindowW;

function initResizeWatcher() {
	// console.log('TECHNOLOGY: initResizeWatcher()');
	$window.on('resize', function() {
		currWindowW = $window.width();
		// console.log('TECHNOLOGY: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= sliderBreakpoint) && (prevWindowW < sliderBreakpoint)) {
			// Unslick mobile photo slider.
			// if ($mySlider.hasClass('slick-initialized')) {
			// 	$mySlider.slick('unslick');
			// }
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < sliderBreakpoint) && (prevWindowW >= sliderBreakpoint)) {
			// Slick mobile slider.
			if (!$mySlider.hasClass('slick-initialized')) {
				$mySlider.slick(mySliderSettings);
			}
		}
		prevWindowW = $window.width();

		// // If slick arrows are hidden, reduce container bottom padding.
		// if (($window.width() < sliderBreakpoint) && ($('.positions-block__nav .slick-arrow').css('display') == 'none')) {
		// 	$('.positions-block__container').css('paddingBottom','84px');
		// } else {
		// 	$('.positions-block__container').css('paddingBottom','');
		// }
	});
}

exports.init = function () {
	// console.log('TECHNOLOGY: exports.init');
    // Run init methods...

	initSlider();
	// initResizeWatcher();
};